import { IconName } from '@/components/Icon';

import { DocumentStatus } from '@/types/document';

export const StatusIcon: Record<string, IconName> = {
  [DocumentStatus.InReview]: 'list-magnifying-glass',
  [DocumentStatus.Rejected]: 'reject',
  [DocumentStatus.Expired]: 'siren',
  [DocumentStatus.Approved]: 'check-fat-outline',
};
